import { Layout } from 'antd';
import { rgba } from 'polished';
import styled from 'styled-components';

import { COLOR } from 'styles/styledComponents/color.model';

const HeaderAnt = Layout.Header;

export const Header = styled(HeaderAnt)`
  height: 80px;
  background: ${COLOR.WHITE} 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 6px ${rgba(COLOR.BLACK, 0.29)};
  opacity: 1;
  line-height: initial;
  z-index: 2;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-left: 37px;
  padding-right: 100px;
`;
